import * as actionTypes from "../../../../actions/actionTypes";
import {updateObject} from "../../../../../utils/utils";

const initialState = {
    success : false,
    loading : false,
    error: null
};

const adminUtilisateursSupprimerGroupeStart = (state,action) => {
    return updateObject(state,{
        ...state,
        success : false,
        loading : true,
        error: null,
    });
};

const adminUtilisateursSupprimerGroupeSuccess = (state,action) => {
    return updateObject(state,{
        ...state,
        success : true,
        loading : false,
        error: null
    });
};

const adminUtilisateursSupprimerGroupeFail = (state,action) => {
    return updateObject(state,{
        ...state,
        success : false,
        loading : false,
        error: action.payload.error
    });
};

const adminUtilisateursSupprimerGroupeReset = (state,action) => {
    return updateObject(state,{
        ...state,
        ...initialState
    });
};





function reducer(state = initialState,action) {

    switch (action.type) {
        case actionTypes.ADMIN_UTILISATEURS_SUPPRIMER_GROUPE_START : return adminUtilisateursSupprimerGroupeStart(state,action);
        case actionTypes.ADMIN_UTILISATEURS_SUPPRIMER_GROUPE_SUCCESS : return adminUtilisateursSupprimerGroupeSuccess(state,action);
        case actionTypes.ADMIN_UTILISATEURS_SUPPRIMER_GROUPE_FAIL : return adminUtilisateursSupprimerGroupeFail(state,action);
        case actionTypes.ADMIN_UTILISATEURS_SUPPRIMER_GROUPE_RESET : return adminUtilisateursSupprimerGroupeReset(state,action);
        default : return state;
    }

}

export default reducer;